/** Convertit un lien de partage Google Drive en adresse d'image directe à l'affichage.
 *  Fonctionne même pour les liens enregistrés avant l'ajout de la conversion dans l'admin. */
export function toImageUrl(url) {
  if (!url) return url;
  const m = url.match(/drive\.google\.com\/(?:file\/d\/|open\?id=)([\w-]+)/);
  if (m) return `https://lh3.googleusercontent.com/d/${m[1]}=w1600`;
  return url;
}

/** Extrait l'identifiant Google Drive d'un lien (file/d, open?id, uc?id, preview, lh3). */
export function getDriveId(url) {
  if (!url) return null;
  const m =
    url.match(/drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?[^#]*?id=)([\w-]+)/) ||
    url.match(/lh3\.googleusercontent\.com\/d\/([\w-]+)/);
  return m ? m[1] : null;
}

/** Adresse de lecture en continu via notre serveur : vidéos et audios Drive lisibles nativement. */
export function toStreamUrl(url) {
  const id = getDriveId(url);
  if (id) return `${process.env.REACT_APP_BACKEND_URL}/api/drive-file/${id}`;
  return url;
}

/** Cache proprement une image cassée (évite l'icône « image introuvable »). */
export function hideOnError(e) {
  const container = e.currentTarget.closest("[data-image-container]") || e.currentTarget;
  container.style.display = "none";
}

/** Adresse de secours quand lh3.googleusercontent.com est momentanément limité : miniature Drive. */
export function toImageFallbackUrl(url) {
  if (!url) return null;
  const m =
    url.match(/lh3\.googleusercontent\.com\/d\/([\w-]+)/) ||
    url.match(/drive\.google\.com\/(?:file\/d\/|open\?id=)([\w-]+)/);
  if (m) return `https://drive.google.com/thumbnail?id=${m[1]}&sz=w1600`;
  return null;
}

/** onError des <img> : réessaie une fois avec l'adresse de secours, puis cache proprement l'image. */
export function handleImgError(e) {
  const el = e.currentTarget;
  if (!el.dataset.retried) {
    const fallback = toImageFallbackUrl(el.src);
    if (fallback && fallback !== el.src) {
      el.dataset.retried = "1";
      el.src = fallback;
      return;
    }
  }
  hideOnError(e);
}
